import { stepsFullPath } from "../stepsPath";

export const step9_2Path = "/9_2";
export const step9_2FullPath = `${stepsFullPath}${step9_2Path}`;
export const step9_2Caption = "Photo & Video intro";
